<template>
	<div
		class="c-drag-select"
		id="container"
		ref="container"
		style="user-select: none; touch-action: none"
	>
		<div class="c-drag-select__box" ref="box" :style="computedStyle"></div>
	</div>
</template>

<script>
import debounce from '@/lib/debounce.js';
import $ from 'jquery';

let getDimensions = (p1, p2) => ({
	width: Math.abs(p1.x - p2.x),
	height: Math.abs(p1.y - p2.y),
});
let collisionCheck = (node1, node2) =>
	node1.left < node2.left + node2.width &&
	node1.left + node1.width > node2.left &&
	node1.top < node2.top + node2.height &&
	node1.top + node1.height > node2.top;
export default {
	props: {
		color: {
			type: String,
			default: 'rgba(var(--p-r), var(--p-g), var(--p-b), 0.5)',
		},
		opacity: {
			type: Number,
			default: 0.7,
		},
	},

	data() {
		return {
			dragStart: false,
			dragging: false,
			scrollTop: 0,
			initialPosition: {
				x: 0,
				y: 0,
			},
			movementPosition: {
				x: 0,
				y: 0,
			},
			container: null,
			scrollContainer: null,
			childNodes: null,
			attribute: 'data-id',

			intersected: [],

			dragFx: null,
			scrollFx: null,
		};
	},

	watch: {
		// hack to update intersected when inactive. Cuz selected can be changed from outside this component
		// selection() {
		// 	if (!this.dragging) {
		// 		this.intersected = this.selection;
		// 	}
		// },
		selection: function () {
			if (this.selection.length === 0) {
				this.intersected = [];
			}
		},
	},

	computed: {
		selection: function () {
			return this.$store.getters['dashboard/selection'] || [];
		},
		computedStyle: function () {
			if (!this.dragging) {
				return '';
			}
			let start = this.initialPosition;
			//start.y = start.y + this.scrollTop;
			let end = this.movementPosition;
			if (!end) {
				return;
			}
			let dimensions = this.getDimensions(start, end);

			let left = start.x;
			let top = start.y;

			if (end.x < start.x) {
				left = end.x;
			}
			if (end.y < start.y) {
				top = end.y;
			}
			let offset = this.container.getBoundingClientRect().top;
			top = top - offset;
			let style = {
				width: `${dimensions.width}px`,
				height: `${dimensions.height}px`,
				top: `${top}px`,
				left: `${left}px`,
			};

			return style;
		},
	},

	methods: {
		onDragStart: function (e) {
			let $block = $(e.target).closest('.c-block__inner');
			if ($block.length > 0) {
				return;
			}
			let $blockDragger = $(e.target).closest('.c-block__dragger');
			if ($blockDragger.length > 0) {
				return;
			}
			this.dragStart = true;
			this.dragging = false;
			this.initialPosition = {
				x: e.clientX,
				y: e.clientY,
			};
			this.movementPosition = {
				x: 0,
				y: 0,
			};
		},
		onDrag: function (e) {
			if (this.dragging) {
				this.drag(e);
			}
			if (this.dragStart) {
				let offsetPosition = {
					x: e.clientX - this.initialPosition.x,
					y: e.clientY - this.initialPosition.y,
				};
				let movement = Math.abs(offsetPosition.x + offsetPosition.y);
				if (movement > 4) {
					this.movementPosition = this.offsetPosition;
					this.dragging = true;
					this.startDrag();
					this.drag(e);
				}
			}
		},
		onDragEnd: function (e) {
			if (!this.dragging) {
				let el = e.target;
				let condition = $(el).closest('.c-export');
				if (condition.length === 0) {
					this.$store.dispatch('dashboard/unsetSelection');
				}
			}
			this.scrollTop = 0;
			this.dragStart = false;
			this.dragging = false;
			this.endDrag();
		},

		startDrag: function () {
			this.childNodes = $('.hook-block-children')[0].childNodes;
			this.$emit('dragStart');
		},
		drag: function (e) {
			let gap = 2;

			let x = e.clientX;
			let y = e.clientY;
			let rect = this.container.getBoundingClientRect();

			if (x < gap) {
				x = gap;
			}
			if (x > rect.width - gap) {
				x = rect.width - gap;
			}
			if (y < gap) {
				y = gap;
			}
			if (y > rect.height - gap) {
				y = rect.height - gap;
			}

			this.movementPosition = {
				x: x,
				y: y,
			};

			this.intersection();
		},
		endDrag: function () {
			this.$emit('dragEnd');
		},

		onScroll: function () {
			if (this.moving) {
				this.scrollTop = this.scrollContainer.scrollTop;
			}
		},

		getCoords: (e) => {
			let scroll = 0; //container.scrollTop;
			let rect = this.container.getBoundingClientRect();
			let offset = 0; //self.initialOffset;
			return {
				x: e.clientX - rect.left,
				y: e.clientY - rect.top - scroll - offset,
			};
		},
		getDimensions: (p1, p2) => ({
			width: Math.abs(p1.x - p2.x),
			height: Math.abs(p1.y - p2.y),
		}),
		intersection: function () {
			const rect = this.$refs.box.getBoundingClientRect();
			let intersected = [];
			let children = this.childNodes;
			let attribute = this.attribute;
			let attr = '';
			if (!children) {
				return;
			}
			for (let i = 0; i < children.length; i++) {
				if (collisionCheck(rect, children[i].getBoundingClientRect())) {
					let attr = children[i].getAttribute(attribute);
					if (attr) {
						intersected.push(attr);
					}
					// if (children[i].hasAttribute(self.attribute)) {
					// 	intersected.push(attr);
					// }
				}
			}
			this.intersected = intersected;
			this.$store.dispatch('dashboard/setSelection', this.intersected);
		},
	},

	mounted() {
		const $container = $('.hook-container');
		const $scrollContainer = $('.c-dashboard');
		let container = $container[0];
		this.container = container;
		this.scrollContainer = $scrollContainer[0];

		this.dragFx = debounce(this.onDrag, 5);
		this.scrollFx = debounce(this.onScroll, 5);

		// this doesnt work cuz scroll doesnt fire when something is being dragged. We'll need to make our own scrolling mechanism in the future
		//this.scrollContainer.addEventListener('scroll', this.scrollFx);
		this.container.addEventListener('mousedown', this.onDragStart);
		window.addEventListener('mousemove', this.dragFx);
		window.addEventListener('mouseup', this.onDragEnd);
	},

	beforeDestroy: function () {
		//this.scrollContainer.removeEventListener('scroll', this.scrollFx);
		this.container.removeEventListener('mousedown', this.onDragStart);
		window.removeEventListener('mousemove', this.dragFx);
		window.removeEventListener('mouseup', this.onDragEnd);
	},
};
</script>

<style lang="scss">
.c-drag-select {
	position: static;
	&__box {
		top: 0;
		left: 0;
		position: absolute;
		z-index: var(--z-index-2);
		background-color: rgba(var(--p-r), var(--p-g), var(--p-b), 0.5);
	}
}
</style>